<p-dialog-container>
    <p-dialog-header [title]="'UserProfile.Security.AppSetup.header' | translate"></p-dialog-header>
    <div class="p-dialog-content app-setup">
        <div class="app-setup__instructions">
            <p-icon name="smartphone" color="base-disabled"></p-icon>
            <span>{{ 'UserProfile.Security.AppSetup.instructions' | translate }}</span>
        </div>

        <div class="app-setup__body">
            <ng-container *ngIf="enrollment; else loading">
                <img class="app-setup__qr" [src]="enrollment.qrImageDataUri" alt="QR code" automation-id="authenticator_qr" />
                <p-link (onClick)="toggleManualKey()" automation-id="authenticator_toggle_key">
                    {{ 'UserProfile.Security.AppSetup.showManualKey' | translate }}
                </p-link>
                <div class="app-setup__key" *ngIf="showManualKey" automation-id="authenticator_setup_key">
                    <span class="app-setup__key-label">{{ 'UserProfile.Security.AppSetup.manualKeyLabel' | translate }}</span>
                    <code>{{ enrollment.setupKey }}</code>
                </div>
            </ng-container>
            <ng-template #loading>
                <pui-spinner></pui-spinner>
            </ng-template>

            <p-otp-input class="app-setup__code" [formControl]="code" [hasError]="!!errorMsg" (completed)="verify()"></p-otp-input>
            <div class="app-setup__error" *ngIf="errorMsg" automation-id="authenticator_error">{{ errorMsg | translate }}</div>
        </div>
    </div>
    <p-dialog-footer [btnConfig]="footerConfig"></p-dialog-footer>
</p-dialog-container>
